import {gql} from '@apollo/client'

export const DOWNLOAD_PRESIGNER = gql`
  query DownloadPresigner($uploadId: ID!, $id: ID!) {
    downloadPresigner(uploadId: $uploadId, id: $id) {
      id
      uploadId
      filename
      presignedUrl
      expiresAt
    }
  }
`
